import { productEmbedType } from './analyticsWebTypes';
export const isFirstParty = input => {
  return input.embeddedType === productEmbedType.FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
export const isThirdParty = input => {
  return input.embeddedType === productEmbedType.THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};